export interface ExperienceItem {
  period: string;
  company: string;
  role: string;
  description: string;
  highlights: string[];
}

export const experiences: ExperienceItem[] = [
  {
    period: "2026.02 — 2026.07",
    company: "피플앤드테크놀러지",
    role: "의료정보시스템 및 모바일 서비스 개발 · 프리랜서",
    description: "병원 자산·차용 대여 업무 화면과 모바일·외부 장비 기능을 연결했습니다.",
    highlights: [
      "Nexacro 기반 웹 화면과 Android 네이티브 기능 연동",
      "수액기기·체중계 BLE 연동과 XPush·FCM 알림 개선",
      "앱 위변조·루팅 탐지와 워치 업무 알림 고도화",
    ],
  },
  {
    period: "2025.08 — 2025.12",
    company: "국민건강보험공단 일산병원",
    role: "의료정보시스템 및 모바일 서비스 개발 · 프리랜서",
    description: "병원 웹 업무 화면, Android PDA와 의료 장비를 통합한 업무 시스템을 개발했습니다.",
    highlights: [
      "Nexacro 의료정보시스템 화면과 Android PDA 개발",
      "웹·네이티브 통신과 바코드·BLE 의료기기 연동",
      "FCM·XPush 기반 업무 알림과 푸시 수신 개선",
    ],
  },
  {
    period: "2017.04 — 2025.05",
    company: "에스엘솔루션",
    role: "웹·모바일 및 SDK 개발 · 책임연구원",
    description: "TMap SDK, 위치·센서 기반 서비스, 화물 관제 앱과 백엔드 API를 개발하며 모바일 플랫폼과 서버 전반을 담당했습니다.",
    highlights: [
      "TMap Android·iOS SDK 개발 및 메모리·생명주기 안정화",
      "React Native 기반 화물 관제·배차 서비스 개발",
      "Spring 기반 날씨·미세먼지 API와 위치·센서 SDK 개발",
    ],
  },
  {
    period: "2015.03 — 2016.08",
    company: "에스엠소프트웨어",
    role: "웹·모바일·데스크톱 애플리케이션 개발 · 연구원",
    description: "CAD 데이터 기반 자동 도면과 산업 설비 모니터링, 공공 웹·모바일 서비스를 개발했습니다.",
    highlights: [
      "JavaScript·Java·Node.js 기반 자동 도면 시스템 개발",
      "태양광 발전소 모니터링과 스마트마을방송 앱 개발",
      "전라남도 섬 정보 웹사이트 개발",
    ],
  },
];
